<div class="summary"
  *ngIf="trainsInfo?.selectedTrains?.selectedOutwardTrain && trainsInfo?.selectedTrains?.selectedOutwardAlternatives">
  <p class="search-data">{{ 'my-bookeds.train.summary' | translate}}</p>
  <div class="summary-content">
    <div *ngIf="!isPriceWithinRangeMethod() || trainsInfo.userFilters.onlyTrainAuthorization"
      style="display: flex; justify-content: center;">
      <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
    </div>
    <p style="margin: 0;font-weight: 600;">{{ "train.search-result.outward-train" | translate }}</p>
    <mat-accordion>
      <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="time-container">
              <div class="journey-container">
                <div class="time-line">
                  <div class="dot"></div>
                  <div class="line"></div>
                  <div class="dot"></div>
                </div>
                <div class="hours">
                  <p>
                    <span>{{ trainsInfo?.selectedTrains?.selectedOutwardTrain?.departDate | date:'HH:mm' }}</span>
                    <span>{{ trainsInfo?.searchConfig?.origin?.name }}</span>
                  </p>
                  <div class="duration-sections">
                    <span>{{ trainService.getDuration(trainsInfo?.selectedTrains?.selectedOutwardTrain) }},</span>
                    <span *ngIf="trainsInfo?.selectedTrains?.selectedOutwardTrain?.sections.length > 1">
                      {{trainsInfo?.selectedTrains?.selectedOutwardTrain.sections.length - 1 }} {{
                      ((trainsInfo?.selectedTrains?.selectedOutwardTrain.sections.length === 2 ?
                      'train.search-result.stop' :
                      'train.search-result.stops' ) |translate) }}
                    </span>
                    <span
                      *ngIf="!trainsInfo?.selectedTrains?.selectedOutwardTrain?.sections || trainsInfo?.selectedTrains?.selectedOutwardTrain?.sections.length <= 1">
                      {{ 'train.no-stops' | translate }}
                    </span>
                    <div *ngFor="let section of trainsInfo?.selectedTrains?.selectedOutwardTrain?.sections">
                      <img class="carrier-logo" [src]="trainService.getCarrierLogo(section?.carrier)" alt="Carrier logo" />
                    </div>
                    <span>{{"common.see-extras" | translate}}</span>
                  </div>
                  <p>
                    <span>{{ trainsInfo?.selectedTrains?.selectedOutwardTrain?.arriveDate | date:'HH:mm' }}</span>
                    <span>{{ trainsInfo?.searchConfig?.destination?.name }}</span>
                  </p>
                </div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="journey">
            <p>{{ 'common.duration' | translate }}: {{trainService.getDuration(trainsInfo?.selectedTrains?.selectedOutwardTrain)}}</p>
            <div *ngFor="let section of trainsInfo?.selectedTrains?.selectedOutwardTrain?.sections; let i = index">
              <div class="wait-duration" *ngIf="i !== 0">
                <span>{{'train.transfer-time' | translate}}: </span>
                <span>{{getWaitDuration(trainsInfo?.selectedTrains?.selectedOutwardTrain, i-1)}}</span>
              </div>
              <div class="section">
                <div class="time-line">
                  <div class="dot"></div>
                  <div class="line"></div>
                  <div class="dot"></div>
                </div>
                <div class="section-container">
                  <div class="origin">
                    <span>{{ section.departDate | date:'HH:mm' }}</span>
                    <span>{{ section.origin }}</span>
                  </div>
                  <div>
                    <div class="duration">
                      <span>{{ trainService.getDuration(section) }}</span>
                      <span>{{ section.trainNumber }}</span>
                      <span>{{ section.fareName }}</span>
                      <img class="carrier-logo" [src]="trainService.getCarrierLogo(section?.carrier)" alt="" />
                    </div>
                    <div>
                      <span *ngFor="let extra of trainsInfo?.selectedTrains?.selectedOutwardTrain?.includedExtras">{{ extra.description }}</span>
                    </div>
                  </div>
                  <div class="origin">
                    <span>{{ section.arriveDate | date:'HH:mm' }}</span>
                    <span>{{ section.destination }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> 
      </mat-expansion-panel>
    </mat-accordion>
    <div *ngIf="trainsInfo?.selectedExtras?.outward">
      <div *ngFor="let extra of trainsInfo.selectedExtras.outward" class="extra">
        <span>{{ "flight.multifamily.extra" | translate }}: </span>
        <span>{{extra.description}} x{{extra.quantity}}</span>
      </div>
    </div>
    <div *ngIf="trainsInfo?.selectedSeats?.outward">
      <div *ngFor="let seat of trainsInfo.selectedSeats.outward" class="extra">
        <span>{{ "flight.multifamily.seats" | translate }}: </span>
        <span>{{getSeatText(seat)}}</span>
      </div>
    </div>
  </div>
  <div class="summary-content"
    *ngIf="trainsInfo?.selectedTrains?.selectedReturnTrain && trainsInfo?.selectedTrains?.selectedReturnAlternatives">
    <p style="margin: 0;font-weight: 600;">{{ "train.search-result.return-train" | translate }}</p>
    <mat-accordion>
      <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="time-container">
              <div class="journey-container">
                <div class="time-line">
                  <div class="dot"></div>
                  <div class="line"></div>
                  <div class="dot"></div>
                </div>
                <div class="hours">
                  <p>
                    <span>{{ trainsInfo?.selectedTrains?.selectedReturnTrain?.departDate | date:'HH:mm' }}</span>
                    <span>{{ trainsInfo?.searchConfig?.destination?.name }}</span>
                  </p>
                  <div class="duration-sections">
                    <span>{{ trainService.getDuration(trainsInfo?.selectedTrains?.selectedReturnTrain) }},</span>
                    <span *ngIf="trainsInfo?.selectedTrains?.selectedReturnTrain.sections.length > 1">
                      {{trainsInfo?.selectedTrains?.selectedReturnTrain.sections.length - 1 }} {{
                      ((trainsInfo?.selectedTrains?.selectedReturnTrain.sections.length === 2 ?
                      'train.search-result.stop' :
                      'train.search-result.stops' ) |translate) }}
                    </span>
                    <span
                      *ngIf="!trainsInfo?.selectedTrains?.selectedReturnTrain?.sections || trainsInfo?.selectedTrains?.selectedReturnTrain?.sections.length <= 1">
                      {{ 'train.no-stops' | translate }}
                    </span>
                    <div *ngFor="let section of trainsInfo?.selectedTrains?.selectedReturnTrain?.sections">
                      <img class="carrier-logo" [src]="trainService.getCarrierLogo(section?.carrier)" alt="Carrier logo" />
                    </div>
                    <span>{{"common.see-extras" | translate}}</span>
                  </div>
                  <p>
                    <span>{{ trainsInfo?.selectedTrains?.selectedReturnTrain?.arriveDate | date:'HH:mm' }}</span>
                    <span>{{ trainsInfo?.searchConfig?.origin?.name }}</span>
                  </p>
                </div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="journey">
            <p>{{ 'common.duration' | translate }}: {{trainService.getDuration(trainsInfo?.selectedTrains?.selectedReturnTrain)}}</p>
            <div *ngFor="let section of trainsInfo?.selectedTrains?.selectedReturnTrain?.sections; let i = index">
              <div class="wait-duration" *ngIf="i !== 0">
                <span>{{'train.transfer-time' | translate}}: </span>
                <span>{{getWaitDuration(trainsInfo?.selectedTrains?.selectedReturnTrain, i-1)}}</span>
              </div>
              <div class="section">
                <div class="time-line">
                  <div class="dot"></div>
                  <div class="line"></div>
                  <div class="dot"></div>
                </div>
                <div class="section-container">
                  <div class="origin">
                    <span>{{ section.departDate | date:'HH:mm' }}</span>
                    <span>{{ section.origin }}</span>
                  </div>
                  <div>
                    <div class="duration">
                      <span>{{ trainService.getDuration(section) }}</span>
                      <span>{{ section.trainNumber }}</span>
                      <span>{{ section.fareName }}</span>
                      <img class="carrier-logo" [src]="trainService.getCarrierLogo(section?.carrier)" alt="" />
                    </div>
                    <div>
                      <span *ngFor="let extra of trainsInfo?.selectedTrains?.selectedReturnTrain?.includedExtras">{{ extra.description }}</span>
                    </div>
                  </div>
                  <div class="origin">
                    <span>{{ section.arriveDate | date:'HH:mm' }}</span>
                    <span>{{ section.destination }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> 
      </mat-expansion-panel>
    </mat-accordion>
    <div *ngIf="trainsInfo?.selectedExtras?.return">
      <div *ngFor="let extra of trainsInfo.selectedExtras.return" class="extra">
        <span>{{ "flight.multifamily.extra" | translate }}: </span>
        <span>{{extra.description}} x{{extra.quantity}}</span>
      </div>
    </div>
    <div *ngIf="trainsInfo?.selectedSeats?.return">
      <div *ngFor="let seat of trainsInfo.selectedSeats.return" class="extra">
        <span>{{ "flight.multifamily.seats" | translate }}: </span>
        <span>{{getSeatText(seat)}}</span>
      </div>
    </div>
  </div>
  <div>
    <div class="total-price base-price">
      <p>{{ "hotel.base-rate" | translate }}:</p>
      <p>{{ trainService.calculateProviderPrice(trainsInfo) | price }} €</p>
    </div>
    <div class="total-price fee-emit" *ngIf="activePage !== 'result' && trainService.calculateExtras(trainsInfo) !== '0.00'">
      <p>{{ "flight.form-flight.extras" | translate }}:</p>
      <p>{{ trainService.calculateExtras(trainsInfo) }} €</p>
    </div>
    <div class="total-price fee-emit" *ngIf="activePage === 'confirm'">
      <p>{{ "flight.result-flight.fee-emit" | translate }}:</p>
      <p>{{ trainService.calculateFees(trainsInfo) }} €</p>
    </div>
    <div class="total-price total-price-label" *ngIf="activePage === 'confirm'">
      <p>{{ "flight.result-flight.total-price" | translate }}:</p>
      <p>{{ trainService.calculateFinalPrice(trainsInfo) }} €</p>
    </div>
  </div>
  <!--results-->
  <div *ngIf="activePage === 'result'" class="button-cont">
    <button class="next-button" *ngIf="onView === 'outward' && !trainsInfo?.searchConfig?.oneWay"
      [disabled]="!(trainsInfo?.selectedTrains?.selectedOutwardTrain && trainsInfo?.selectedTrains?.selectedOutwardAlternatives)"
      [ngClass]="{'disabled-button': !(trainsInfo?.selectedTrains?.selectedOutwardTrain && trainsInfo?.selectedTrains?.selectedOutwardAlternatives)}"
      (click)="onSearchReturn()">
      {{ "train.form-train.returning" | translate }}
    </button>
    <button class="next-button" *ngIf="onView === 'return'" (click)="onViewDepart()">
      {{ "train.form-train.going" | translate }}
    </button>
    <button class="next-button"
      [disabled]="!((trainsInfo?.selectedTrains?.selectedOutwardTrain && trainsInfo?.selectedTrains?.selectedOutwardAlternatives && !trainsInfo?.searchConfig?.returnDate) || (trainsInfo?.selectedTrains?.selectedReturnTrain && trainsInfo?.selectedTrains?.selectedReturnAlternatives))"
      [ngClass]="{'disabled-button': !((trainsInfo?.selectedTrains?.selectedOutwardTrain && trainsInfo?.selectedTrains?.selectedOutwardAlternatives && !trainsInfo?.searchConfig?.returnDate) || (trainsInfo?.selectedTrains?.selectedReturnTrain && trainsInfo?.selectedTrains?.selectedReturnAlternatives))}"
      (click)="onSelectTrains()"
      *ngIf="(onView === 'return' && trainsInfo?.selectedTrains?.selectedReturnTrain && trainsInfo?.selectedTrains?.selectedReturnAlternatives) || (onView === 'outward' && trainsInfo?.selectedTrains?.selectedOutwardTrain && trainsInfo?.selectedTrains?.selectedOutwardAlternatives && trainsInfo?.searchConfig?.oneWay)">
      {{ "flight.detail-flight.next" | translate }}
    </button>
  </div>
  <!--passengers-->
  <div *ngIf="activePage === 'passengers'">
    <button (click)="trainsInfo?.travellersForm?.valid ? goNextStep() : null" class="custom-btn"
      [ngClass]="{disabled: !trainsInfo?.travellersForm?.valid}"
      [matTooltip]="!trainsInfo?.travellersForm?.valid ? getInvalidString() : null">
      {{ "flight.result-flight.continue" | translate }}
    </button>
  </div>
  <!--extras-->
  <div *ngIf="activePage === 'extras'">
    <button (click)="onSelectExtras()" class="custom-btn">
      {{ "flight.result-flight.continue" | translate }}
    </button>
  </div>
  <!--confim-->